<template>
	<div class="file-uploader">
		<hidden-file-uploader
			ref="uploader"
			:accept="accept"
			:fingerprint="fingerprint"
			:project-id="projectId"
			:question-id="message.question_id"
			@success="sendMessage"
			@failed="sendError"
		>
			<template v-slot:action="{ file, loading }">
				<file-preview
					v-if="file"
					:file="file"
					:loading="loading"
					:record-voice="recordVoice"
					:duration="recordDuration"
				/>
				<template v-else>
					<voice-recorder v-if="recordVoice" @uploadRecording="uploadRecording" />
					<q-btn
						v-else
						icon="note_add"
						label="Choose File"
						color="primary"
						class="upload-button"
					/>
				</template>
			</template>
		</hidden-file-uploader>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import HiddenFileUploader from '@/components/HiddenFileUploader';
import FilePreview from '@/components/MessageTypes/FileUploader/FilePreview.vue';
import VoiceRecorder from '@/components/MessageTypes/FileUploader/VoiceRecorder/index.vue';

export default defineComponent({
	name: 'FileUploader',
	components: {
		VoiceRecorder,
		FilePreview,
		HiddenFileUploader
	},
	props: {
		message: {
			type: Object
		},
		projectId: {
			type: String
		},
		fingerprint: {
			type: Object
		}
	},
	data() {
		return {
			file: null,
			loading: false,
			recordDuration: '00:00'
		};
	},
	computed: {
		accept() {
			return this.message.file_extensions.mimes.join(', ');
		},
		recordVoice() {
			return (
				this.message.file_extensions.slugs.length === 1 &&
				this.message.file_extensions.slugs[0] === 'audio_type' &&
				this.message.record_voice
			);
		}
	},
	methods: {
		uploadRecording(file, duration) {
			const uploader = this.$refs.uploader;
			this.recordDuration = duration;
			if (uploader) {
				uploader.file = file;
				this.$nextTick(() => uploader.uploadFile());
			}
		},

		sendMessage(file) {
			this.$emit('send-message', {
				attachmentId: file.id,
				text: this.recordVoice
					? `${this.$t('voiceRecording')} ${this.recordDuration}`
					: file.name
			});
			this.destroy();
		},
		sendError(message) {
			this.$emit('send-message', {
				attachmentError: message,
				text: this.recordVoice
					? `${this.$t('voiceRecording')} ${this.recordDuration}`
					: message
			});
			this.destroy();
		},
		destroy() {
			this.$el.parentNode?.removeChild(this.$el);
		}
	}
});
</script>

<style scoped lang="scss">
.upload_control {
	display: none;
}

.upload-button {
	border-radius: 8px;
	height: 40px;
	width: 100%;
}

@media screen and (min-width: 767px) {
	.file-uploader {
		display: flex;
	}
	.upload-button {
		height: 60px;
		width: 184px;
		border-radius: 0.5rem;
	}
}
</style>
